import React from "react";
import PropTypes from "prop-types";

export default function StudioWorkbench({
  title = null,
  toolbar = null,
  navigator = null,
  viewport = null,
  inspector = null,
}) {
  return (
    <section className="studio-framework-workbench">
      {(title || toolbar) && (
        <header className="studio-framework-workbench__header">
          <div className="studio-framework-workbench__title">
            {title}
          </div>

          {toolbar && (
            <div className="studio-framework-workbench__toolbar">
              {toolbar}
            </div>
          )}
        </header>
      )}

      <div
        className={[
          "studio-framework-workbench__content",
          navigator
            ? "studio-framework-workbench__content--with-navigator"
            : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {navigator && (
          <div className="studio-framework-workbench__navigator">
            {navigator}
          </div>
        )}

        <div
          className={[
            "studio-framework-workbench__body",
            inspector
              ? "studio-framework-workbench__body--with-inspector"
              : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div className="studio-framework-workbench__viewport">
            {viewport}
          </div>

          {inspector && (
            <aside className="studio-framework-workbench__inspector">
              {inspector}
            </aside>
          )}
        </div>
      </div>
    </section>
  );
}

StudioWorkbench.propTypes = {
  title: PropTypes.node,
  toolbar: PropTypes.node,
  navigator: PropTypes.node,
  viewport: PropTypes.node,
  inspector: PropTypes.node,
};
